import { useState } from "react";
import "./App.css";
import Content from "./components/content/Content";
import Menu from "./components/menu/Menu";
import MenuFilter from "./components/menu/MenuFilter";

function App() {
  const [filterType, setFilterType] = useState("initialPage");
  const [showFilter, setShowFilter] = useState(false);
  const [category, setCategory] = useState("Apicultura");
  const [natureza, setNatureza] = useState(null);
  const [subcategoria, setSubCategory] = useState(null);
  const [selectedOption, setChanged] = useState("Número de inscrição");
  const [searchInput, onSearchChange] = useState("");

  // Alterar aqui caso precise exibir menuFilter para Health
  const handleMenuItemClick = (value) => {
    let showFilterModal = true;
    
    if(value === 'initialPage' || value === 'health' || value === 'agritourism' || value === 'education' || value === 'social' || value === 'ambiental' || value === 'fabricados' || value === 'obra' || value === 'infra') {
      showFilterModal = false;
    }
    setFilterType(value);
    setShowFilter(showFilterModal);
  };

  const handleCategory = (value) => {
    setCategory(value);
  };

  const handleNatureza = (value) => {
    setNatureza(value);
  };

  const handleSubCategory = (value) => {
    setSubCategory(value);
  };

  const onSelectChange = (value) => {
    setChanged(value);
  };

  const renderedMenu = showFilter ? (
    <MenuFilter
      handles={{
        handleCategory,
        handleSubCategory,
        handleNatureza,
      }}
      filterControl = {{
        selectedOption,
        onSelectChange,
        onSearchChange,
      }}
    />
  ) : (
    <Menu onFilterClick={handleMenuItemClick} />
  );

  return (
    <div className="App">
      {renderedMenu}
      <Content
        view={filterType}
        menuFilterParams = {{
          category,
          subcategoria,
          natureza
        }}
        filterControl = {{
          onFilterClick: handleMenuItemClick,
          selectedOption,
          searchInput
        }}
      />
    </div>
  );
}

export default App;
